import { Colors } from "@auteco/theme"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    dialogContent: {
        width: 'auto',
        minWidth: '300px',
        minHeight: '300px',
        padding: '12px 24px',
        borderBottom: '2px solid #f0f0f0'
    },
    advice: {
        marginBottom: '8px'
    },
    materialsTitle: {
        margin: '12px 0',
        textAlign: 'center',
        fontWeight: 'bold',
        color: Colors.DARK_BLUE
    },
    materialsContainer: {
        maxHeight: '200px',
        overflowY: 'auto',
        border: `2px solid ${Colors.DARK_GRAY_BACKGROUND}`,
        // background: Colors.GRAY_BACKGROUND,
        borderRadius: '4px',
        '& div:last-child': {
            borderBottom: 0
        },
    },
    material: {
        width: '100%',
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        borderBottom: `2px solid ${Colors.DARK_GRAY_BACKGROUND}`
    },
    materialTxt: {
        margin: '0'
    },
    btnsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '12px 0'
    },
    closeBtn: {
        width: '120px',
    },
    deleteBtn: {
        width: '120px',
        backgroundColor: Colors.DARK_BLUE,
        marginRight: '12px',
        '&:hover': {
            backgroundColor: Colors.DARK_BLUE,
        }
    }
}))

export default useStyles